import React from "react";
import styled from "styled-components";

const Temp = () => {
  return (
    <Con>
      {" "}
      <iframe
        src="https://my.spline.design/worldplanet-nJ1hDpqviazrKDdUgoOm8vrV/"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </Con>
  );
};

const Con = styled.div`
  height: 200vh;
`;

export default Temp;
